import type { CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import {
	allPageStatusFilterValueKeys,
	isPageStatusFilterValueKey,
	PageStatusFilterValue,
} from '../../../../../common/constants/filters/page-status-filter';
import type {
	FetchedSelectFilterOption,
	SelectFilterState,
} from '../../../../../common/constants/filters/select-filter/types';

import { pageStatusLabels } from './messages';

export const getAllPageStatusOptions = (config: CloudConfig): FetchedSelectFilterOption[] => {
	const allOption = {
		value: 'all',
		trackingKey: 'all',
		queryParamValue: 'all',
		isDefault: true,
		label: config.intl?.formatMessage(pageStatusLabels['all']) ?? '',
		product: config.product,
	};

	const pageStatusOptions = allPageStatusFilterValueKeys.map((key) => ({
		value: PageStatusFilterValue[key],
		trackingKey: key,
		queryParamValue: key,
		isDefault: false,
		label: config.intl?.formatMessage(pageStatusLabels[key]) ?? '',
		product: config.product,
	}));

	return [allOption, ...pageStatusOptions];
};

export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>): SelectFilterState<ID> => {
		const queryParamValue = queryParams[queryParamKey];

		let value: string[] | undefined;
		
		if (Array.isArray(queryParamValue)) {
			if (queryParamValue[0] === 'all') {
				value = queryParamValue;
			} else if (isPageStatusFilterValueKey(queryParamValue[0])) {
				value = [PageStatusFilterValue[queryParamValue[0]]];
			}
		}

		return {
			...initialState,
			value: value || initialState.value,
		};
	};
};
